import styled from '@emotion/styled';
import { neutralVariant } from '../../../styles';
import { SelectChipProps } from './SelectChip';
import { shouldForwardProps } from '../../../utils';
import { Chip } from '@mui/material';

const KernChip = styled(Chip, shouldForwardProps)<{ backgroundColor?: string; fontColor?: string }>`
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    border-radius: 4px;
    color: ${({ theme, fontColor }) => fontColor ?? theme.colors.onSurfaceVariant};
    background-color: ${({ theme, backgroundColor }) => backgroundColor ?? theme.colors.background};
    padding-left: -2px;
    padding-right: -2px;
    padding-top: 6px;
    padding-bottom: 6px;
    & > svg {
        width: 16px;
    }
`;

const StyledChip = styled(KernChip, shouldForwardProps)<Pick<SelectChipProps, 'isSelected'>>`
    border: ${({ theme, isSelected }) =>
        `1px solid ${isSelected ? 'transparent' : theme.colors.outline}`};
    border-radius: 1.5;
    background-color: ${({ theme, isSelected }) =>
        isSelected ? theme.colors.primaryContainer : neutralVariant[100]};
    color: ${({ theme, isSelected }) =>
        isSelected ? theme.colors.onPrimaryContainer : theme.colors.onSurfaceVariant};
    font-weight: 500;
    width: fit-content;
    .MuiChip-icon {
        color: ${({ theme, isSelected }) =>
            isSelected ? theme.colors.onPrimaryContainer : theme.colors.onSurfaceVariant};
    }

    // to prevent sticky hover on touch devices
    @media (hover: none) {
        :focus {
            background-color: ${({ theme, isSelected }) =>
                isSelected ? theme.colors.primaryContainer : 'transparent'};
        }
    }
`;

export { StyledChip, KernChip };
